module.exports = __webpack_public_path__ + "static/media/SZ45003W_02.2cd3968a.png";